var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h4',{staticClass:"mb-4"},[_vm._v(" "+_vm._s(_vm.$t("account.set_phone_login_title", "Login by Phone"))+" ")]),_c('accountSetPhoneLogin',{attrs:{"defaultCountry":_vm.defaultCountry}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }